import { Instagram, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import footerLogo from "@/assets/alluring-aesthetic-footer-logo.webp";

const Footer = () => {
  const navigate = useNavigate();

  const handleOurStoryClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname === "/") {
      document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#about");
    }
  };

  const shopLinks = [
  { name: "All Products", href: "/shop" },
  { name: "Lips", href: "/shop?category=Lips" },
  { name: "Eyes", href: "/shop?category=Eyes" },
  { name: "Face", href: "/shop?category=Face" },
  { name: "Gift Sets", href: "/shop?category=Gift+Sets" }];


  const aboutLinks = [
  { name: "Our Story", href: "/#about", onClick: handleOurStoryClick },
  { name: "Contact Us", href: "/contact" },
  { name: "FAQs", href: "/faq" }];


  const legalLinks = [
  { name: "Privacy Policy", href: "/privacy-policy" },
  { name: "Terms of Service", href: "/terms" },
  { name: "Shipping & Returns", href: "/shipping-returns" }];


  const socialLinks = [
  { icon: Instagram, href: "https://www.instagram.com/tryalluringaesthetic?igsh=NWF5aHptMG13dHM2&utm_source=qr", label: "Instagram" }];


  return (
    <footer id="contact" className="bg-card border-t border-border">
      <div className="container mx-auto px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 sm:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="mb-6 block">
              <img src={footerLogo} alt="Alluring Aesthetic" width={186} height={80} loading="lazy" decoding="async" className="h-16 sm:h-20 w-auto" />
            </Link>

            {/* Email */}
            <div className="flex items-center gap-3 text-sm text-muted-foreground mb-6">
              <Mail className="w-4 h-4 text-primary" />
              <span className="font-subtitle">support@alluringaesthetic.org</span>
            </div>

            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social, index) =>
              <a
                key={index}
                href={social.href}
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300">

                  <social.icon className="w-4 h-4" aria-hidden="true" />
                </a>
              )}
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h2 className="font-display text-lg font-medium text-foreground mb-4">Shop</h2>
            <ul className="space-y-3">
              {shopLinks.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.href}
                  className="font-subtitle text-sm text-muted-foreground hover:text-primary transition-colors">

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h2 className="font-display text-lg font-medium text-foreground mb-4">About</h2>
            <ul className="space-y-3">
              {aboutLinks.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.href}
                  onClick={link.onClick}
                  className="font-subtitle text-sm text-muted-foreground hover:text-primary transition-colors">

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h2 className="font-display text-lg font-medium text-foreground mb-4">Legal</h2>
            <ul className="space-y-3">
              {legalLinks.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.href}
                  className="font-subtitle text-sm text-muted-foreground hover:text-primary transition-colors">

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border flex justify-center items-center">
          <p className="font-subtitle text-sm text-muted-foreground">© {new Date().getFullYear()} Alluring Aesthetic. All rights reserved.

          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;